import request from '@/utils/request'

export function getWaterVoucherPurchasePage(params: {
  pageNum: number
  pageSize: number
  userPhone?: string
  orderNumber?: string
  status?: number
  storeId?: number
  packageType?: number
}) {
  return request({
    url: '/record/waterVoucherPurchase/page',
    method: 'get',
    params
  })
}

export function getWaterQuotaPage(params: {
  pageNum: number
  pageSize: number
  userPhone?: string
  userName?: string
  storeId?: number
  /** 默认 true：仅剩余桶数 > 0 */
  onlyRemaining?: boolean
}) {
  return request({
    url: '/record/waterQuota/page',
    method: 'get',
    params
  })
}

export function getWaterBucketUsePage(params: {
  pageNum: number
  pageSize: number
  userPhone?: string
  orderNumber?: string
  storeId?: number
}) {
  return request({
    url: '/record/waterBucketUse/page',
    method: 'get',
    params
  })
}

export function getCourierAssignPage(params: {
  pageNum: number
  pageSize: number
  userPhone?: string
  orderNumber?: string
  courierPhone?: string
  storeId?: number
  status?: number | string | null
}) {
  return request({
    url: '/record/courierAssign/page',
    method: 'get',
    params
  })
}

export function getCourierOpLogPage(params: {
  pageNum: number
  pageSize: number
  actionType?: number
  userPhone?: string
  orderNumber?: string
  courierPhone?: string
  storeId?: number
}) {
  return request({
    url: '/record/courierOpLog/page',
    method: 'get',
    params
  })
}

export function getEmptyBucketRecordPage(params: {
  pageNum: number
  pageSize: number
  userPhone?: string
  orderNumber?: string
  storeId?: number
}) {
  return request({
    url: '/record/emptyBucketRecord/page',
    method: 'get',
    params
  })
}

export function getEmptyBucketRefundPage(params: {
  pageNum: number
  pageSize: number
  userPhone?: string
  orderNumber?: string
  status?: number
  storeId?: number
}) {
  return request({
    url: '/emptyBucketRefund/page',
    method: 'get',
    params
  })
}

export function rejectEmptyBucketRefund(id: number, storeId: number | undefined, data: { rejectReason: string; adminRemark?: string }) {
  return request({
    url: `/emptyBucketRefund/${id}/reject`,
    method: 'put',
    params: storeId != null ? { storeId } : undefined,
    data
  })
}

export function markEmptyBucketRefunded(id: number, storeId: number | undefined, data?: { adminRemark?: string }) {
  return request({
    url: `/emptyBucketRefund/${id}/refunded`,
    method: 'put',
    params: storeId != null ? { storeId } : undefined,
    data: data || {}
  })
}
